import { mediaAssetCreatorVideoAdapter } from './media-asset-creator-video.adapter';

export const MediaAssetCreatorVideoActions = mediaAssetCreatorVideoAdapter.getActions();
